<app-button icon="calendar_month"
            type="mat-stroked-button"
            (click)="onClick()">Change dates</app-button>
